import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "410",
  height: "410",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "204.932",
      cy: "204.932",
      r: "204.178",
      stroke: "#4c5ff8",
      "stroke-opacity": ".5",
      "stroke-width": "1.507"
    }, null, -1)
  ]))]))
}
export default { render: render }